import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { useDispatch, useSelector } from "react-redux"
import backend from "api/api"
import Switch from "react-switch"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import servicesIcon1 from "../../../assets/images/services-icon/01.png"
import servicesIcon2 from "../../../assets/images/services-icon/02.png"
import servicesIcon3 from "../../../assets/images/services-icon/03.png"
import "chartist/dist/scss/chartist.scss"
import SearchTable from "../../../components/SearchTable/searchTable"
import { toast, ToastContainer } from "react-toastify"
import { CircularProgress } from "@mui/material"
export default function Admin() {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  let rows = []
  const { users } = useSelector(state => state.GetUserReducer)
  const myAdmin = users.filter(e => e?.role === "admin")
  const myAdminActive = users.filter(
    e => e?.status === "active" && e?.role === "admin"
  )
  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Yes
      </div>
    )
  }
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        No
      </div>
    )
  }
  const myAdminblocked = users.filter(
    e => e?.status === "blocked" && e?.role === "admin"
  )

  const getUsers = async () => {
    try {
      setLoading(true)
      const resp = await backend.get("/api/user")
      setLoading(false)
      dispatch({
        type: "GET_USER_DATA",
        payload: resp.data.data,
      })
    } catch (error) {
      toast.error(error.response?.data.message || error.message || error)
    }
  }

  const changeStatus = async (status, id) => {
    const value = status.props.children == "Active" ? "blocked" : "active"
    const body = {
      status: value,
    }
    const resp = await backend.put(`/api/user/${id}`, body)
    toast.success(resp?.data?.message)
    getUsers()
  }

  const myStatusChange = params => {
    return (
      <>
        <Switch
          uncheckedIcon={<Offsymbol />}
          checkedIcon={<OnSymbol />}
          onColor="#02a499"
          onChange={() => changeStatus(params.status, params.userId)}
          checked={params?.status.props.children === "Active" ? true : false}
        />
        <ToastContainer />
      </>
    )
  }
  const columnhead = [
    { title: "Sr. no#", field: "Srno" },
    { title: "Email", field: "email" },
    { title: "Status", field: "status" },
    { title: "StatusChange", field: "ChangeStatus", render: myStatusChange },
  ]

  if (myAdmin) {
    myAdmin.map((e, i) => {
      rows.push({
        Srno: i + 1,
        userId: e?._id,
        email: e?.email,
        status:
          e?.status === "active" ? (
            <span className="badge bg-success">Active</span>
          ) : (
            <span className="badge bg-danger">Disabled</span>
          ),
      })
    })
  }

  useEffect(() => {
    getUsers()
  }, [])
  const breadcrumbItems = [
    { title: "Dashboard", path: "/triptrader/dashboard" },
    { title: "Admins", path: "#" },
  ]
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Admins | Trip Trader</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </Col>
            </Row>
          </div>
          <Row>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon1} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0">
                      Total Admins
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {myAdmin?.length}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat  text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon2} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 ">
                      Active Admins
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {myAdminActive?.length}{" "}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card
                className="mini-stat  text-white"
                style={{ backgroundColor: "#283c2e" }}
              >
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon3} alt="" />
                    </div>
                    <h4 className="font-size-15 text-uppercase mt-0 ">
                      InActive Admins
                    </h4>
                    <h4 className="fw-medium font-size-24">
                      {myAdminblocked?.length}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {loading ? (
            <CircularProgress />
          ) : (
            <SearchTable columns={columnhead} data={rows} />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}
